export default {
    "revokeCustomerToken": "234f69d7ad308eb9409c4ad03c7b739b3ddaa35e1cb6b30c7ee701088401b61f"
};
